
import { useRef, useState, useEffect } from "react";

export default function Testimonials() {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [hoverItem, setHoverItem] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        root: null,
        threshold: 0.2,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef} 
      className="py-20 md:py-24 relative"
      aria-labelledby="testimonials-heading"
    >
      {/* Subtle background texture */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMyMjIiIGZpbGwtb3BhY2l0eT0iLjAyIj48cGF0aCBkPSJNMzYgMzRjMC0yLjIwOS0xLjc5LTQtNC00cy00IDEuNzkxLTQgNGMwIDIuMjEgMS43OSA0IDQgNHM0LTEuNzkgNC00em0tMjAgMGMwLTIuMjA5LTEuNzktNC00LTRzLTQgMS43OTEtNCA0YzAgMi4yMSAxLjc5IDQgNCA0czQtMS43OSA0LTR6bTQwIDBjMC0yLjIwOS0xLjc5LTQtNC00cy00IDEuNzkxLTQgNGMwIDIuMjEgMS43OSA0IDQgNHM0LTEuNzkgNC00em0tMjAtMjBjMC0yLjIwOS0xLjc5LTQtNC00cy00IDEuNzkxLTQgNGMwIDIuMjEgMS43OSA0IDQgNHM0LTEuNzkgNC00em0tMjAgMGMwLTIuMjA5LTEuNzktNC00LTRzLTQgMS43OTEtNCA0YzAgMi4yMSAxLjc5IDQgNCA0czQtMS43OSA0LTR6bTQwIDBjMC0yLjIwOS0xLjc5LTQtNC00cy00IDEuNzkxLTQgNGMwIDIuMjEgMS43OSA0IDQgNHM0LTEuNzkgNC00em0tMjAtMjBjMC0yLjIwOS0xLjc5LTQtNC00cy00IDEuNzkxLTQgNGMwIDIuMjEgMS43OSA0IDQgNHM0LTEuNzkgNC00em0tMjAgMGMwLTIuMjA5LTEuNzktNC00LTRzLTQgMS43OTEtNCA0YzAgMi4yMSAxLjc5IDQgNCA0czQtMS43OSA0LTR6bTQwIDBjMC0yLjIwOS0xLjc5LTQtNC00cy00IDEuNzkxLTQgNGMwIDIuMjEgMS43OSA0IDQgNHM0LTEuNzkgNC00eiIvPjwvZz48L2c+PC9zdmc+')] opacity-60" />

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto">
          <div 
            className={`max-w-2xl mx-auto opacity-0 ${isVisible ? "animate-fade-in" : ""}`}
            style={{ animationDuration: "0.9s" }}
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-light text-charcoal mb-8 md:mb-10 tracking-tight leading-tight text-center">
              <span className="block font-normal mb-2">Every great transformation</span> 
              <span className="relative inline-block">
                <span className="relative z-10 italic">begins with a conversation.</span>
                <span className="absolute bottom-0 left-0 w-full h-[6px] bg-cream/60 -z-0 transform -translate-y-2"></span>
              </span>
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
}
